function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 120,
  height: 120,
  rx: 60,
  fill: "#6FA4FF",
  fillOpacity: 0.3
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.6924 76.2448L52.4395 77.5958L55.0965 76.2448L60.5007 62.7343L61.8518 58.6812L60.5007 55.9791L55.0965 55.0784L49.6924 55.9791L48.3413 66.1119L49.6924 76.2448Z",
  fill: "#32393F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.9047 76.2448L68.922 77.5958L71.3089 76.2448L72.6599 66.1119L71.3089 55.9791L66.0848 55.0784L60.5005 55.9791V62.7343L65.9047 76.2448Z",
  fill: "#23292D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.2881 76.2448L46.9902 77.5958L49.6923 76.2448C49.6923 75.8255 49.6923 61.8023 49.6923 61.3833L46.9902 60.0322L44.2881 61.3833V76.2448Z",
  fill: "#575F64"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.3081 76.2448L74.0102 77.5958L76.7123 76.2448C76.7123 75.8255 76.7123 61.8023 76.7123 61.3833L74.0102 60.0322L71.3081 61.3833V76.2448Z",
  fill: "#474F54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.5869 61.3833H49.6932C49.6932 60.7295 49.6932 56.6373 49.6932 55.9791L45.6401 54.6281L41.5869 55.9791V61.3833Z",
  fill: "#474F54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.3081 61.3833H79.4144C79.4144 60.7295 79.4144 56.6373 79.4144 55.9791L75.3612 54.6281L71.3081 55.9791V61.3833Z",
  fill: "#32393F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.0957 76.2448L57.7978 77.5959L60.4999 76.2448L61.8509 69.4896L60.4999 62.7344C59.8461 62.7344 55.7538 62.7344 55.0957 62.7344V76.2448Z",
  fill: "#FFDA2D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.5005 76.2448L63.2026 77.5959L65.9047 76.2448C65.9047 75.3326 65.9047 63.6468 65.9047 62.7344C65.2509 62.7344 61.1586 62.7344 60.5005 62.7344V76.2448Z",
  fill: "#FDBF00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.5869 55.979H60.5016L61.8526 53.9524L60.5016 51.9259L51.0442 50.5748L41.5869 51.9259V55.979Z",
  fill: "#575F64"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.5005 55.979H79.4151C79.4151 54.6297 79.4151 53.2752 79.4151 51.9259L69.9578 50.5748L60.5005 51.9259V55.979Z",
  fill: "#474F54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5337 51.9259H60.5015L61.8525 50.5749L60.5015 49.2238L49.0176 47.8728L37.5337 49.2238C37.5337 50.169 37.5337 50.9809 37.5337 51.9259Z",
  fill: "#474F54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.5005 51.9259H83.4683C83.4683 50.9809 83.4683 50.1689 83.4683 49.2238L71.9844 47.8728L60.5005 49.2238V51.9259Z",
  fill: "#32393F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5327 49.2238H60.5005L61.8516 43.112L60.5005 37C59.8687 37.1974 38.1645 43.98 37.5327 44.1775C37.5327 45.7833 37.5327 47.618 37.5327 49.2238Z",
  fill: "#575F64"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.5005 37V49.2238H83.4683C83.4683 47.618 83.4683 45.7832 83.4683 44.1774C82.8383 43.9806 61.1286 37.1964 60.5005 37V37Z",
  fill: "#474F54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.1489 45.1707H60.5L61.1755 43.8197L60.5 42.4686C60.0275 42.4686 59.6214 42.4686 59.1489 42.4686V45.1707Z",
  fill: "#FFDA2D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.5005 45.1707H61.8515C61.8515 44.2257 61.8515 43.4137 61.8515 42.4686C61.379 42.4686 60.973 42.4686 60.5005 42.4686V45.1707Z",
  fill: "#FDBF00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5337 76.2448V83H60.5015L61.8525 79.6224L60.5015 76.2448C58.4327 76.2448 40.5565 76.2448 37.5337 76.2448Z",
  fill: "#474F54"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.5005 83H83.4683C83.4683 81.1811 83.4683 77.3043 83.4683 76.2448C77.4735 76.2448 64.5496 76.2448 60.5005 76.2448V83Z",
  fill: "#32393F"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 46,
  height: 46,
  fill: "white",
  transform: "translate(37.5 37)"
})));

function SvgGovernment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment);
export default __webpack_public_path__ + "static/media/government.d9e19e23.svg";
export { ForwardRef as ReactComponent };